import React, {useEffect} from 'react';
import {Alert, Card, CardBody, CardTitle, Col, FormGroup, Label, Row} from 'reactstrap';
import Printhead from './printhead';
import Vrate from './vrate';
import FormField from '../../components/Common/FormField';
import {useFormContext} from 'react-hook-form';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';

const dryerTypes = [
  {label: 'Brother', value: 'brother'},
  {label: 'Third-Party', value: 'thirdparty'},
];

const Dtrx100 = () => {
  const {
    register,
    formState: {errors},
    watch,
    setError,
    clearErrors,
  } = useFormContext();

  const dryerSerial = watch('dryer_serial');

  useEffect(() => {
    handleChangeDryerSerial();
  }, [dryerSerial]);

  function handleChangeDryerSerial() {
    if (!dryerSerial) return;

    const requiredLength = 20;

    if (dryerSerial.length === requiredLength) {
      const url = process.env.REACT_APP_APIURL + 'dryer/checkduplicate';
      const authToken = authHeader();

      const formData = new FormData();
      formData.append('serial', dryerSerial);

      axios.post(url, formData, {headers: authToken})
          .then((response) => {
            if (response.status === 201) {
              clearErrors('dryer_serial');
            } else {
              setError('dryer_serial', {
                type: 'duplicate',
                message: 'This serial number already exists!',
              });
            }
          })
          .catch(() => {
            setError('dryer_serial', {
              type: 'duplicate',
              message: 'This serial number already exists!',
            });
          });
    }
  }

  return (
    <React.Fragment>
      <Card className="shadow-none border mt-4">
        <CardBody>
          <CardTitle className="mb-3">Dryer-Powder-Unit</CardTitle>
          <FormGroup row>
            <Label md="2" htmlFor="dryer_type" className="col-form-label">Type *</Label>
            <Col md="10">
              <select
                className="form-control"
                {...register('dryer_type', {required: 'Please select a Dryer-Powder-Unit type'})}
              >
                <option value="">Select dryer type</option>
                {dryerTypes.map((pt) => (
                  <option key={pt.value} value={pt.value}>
                    {pt.label}
                  </option>
                ))}
              </select>
              {errors.dryer_type && (
                <p className="text-danger"><small>{errors.dryer_type.message}</small></p>
              )}
            </Col>
          </FormGroup>
          {watch('dryer_type') === 'thirdparty' &&
            <>
              <Row>
                <Label md="2" className="col-form-label">Brand*</Label>
                <Col md="4">
                  <FormField
                    name="dryer_brand"
                    className="form-control"
                    placeholder="Dryer-Powder-Unit Brand"
                    type="text"
                    validate={
                      {
                        required: {value: true},
                      }
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Label md="2" className="col-form-label">Modell*</Label>
                <Col md="4">
                  <FormField
                    name="dryer_model"
                    className="form-control"
                    placeholder="Dryer-Powder-Unit Modell"
                    type="text"
                    validate={
                      {
                        required: {value: true},
                      }
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Label md="2" htmlFor="dryer_width" className="col-form-label">Width*</Label>
                <Col md="4">
                  <FormField
                    name="dryer_width"
                    className="form-control"
                    placeholder="Dryer-Powder-Unit Width"
                    type="text"
                    validate={
                      {
                        required: {value: true},
                      }
                    }
                  />
                </Col>
              </Row>
            </>
          }
          {watch('dryer_type') === 'brother' &&
            <Row>
              <Label md="2" htmlFor="dryer_serial" className="col-form-label">Serial No. *</Label>
              <Col md="4">
                <FormField
                  name="dryer_serial"
                  className="form-control"
                  placeholder="Dryer Serial No. *"
                  type="text"
                  validate={
                    {
                      required: {value: true, message: 'Please provide a valid serial.'},
                      pattern: {value: /^[A-Z]{6}[0-9]{14}$/, message: 'Please provide a valid serial.'},
                    }
                  }
                  maxLength={20}
                  helpMessage="Example: ACUSFY03202602000076."
                />
              </Col>
            </Row>
          }
        </CardBody>
      </Card>
      <Card className="shadow-none border mt-4">
        <CardBody>
          <CardTitle className="mb-3">RIP-Software</CardTitle>
          <FormGroup row>
            <Label md="2" htmlFor="rip_software_name" className="col-form-label">Software Name *</Label>
            <Col md="10">
              <FormField
                name="rip_software_name"
                className="form-control"
                type="text"
                validate={
                  {
                    required: {value: true, message: 'Please provide a valid software name.'},
                  }
                }
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md="2" htmlFor="rip_software_licence_no" className="col-form-label">Licence No</Label>
            <Col md="10">
              <FormField
                name="rip_software_licence_no"
                className="form-control"
                type="text"
              />
            </Col>
          </FormGroup>
        </CardBody>
      </Card>
      <Card className="shadow-none border mt-4">
        <CardBody>
          <CardTitle className="mb-3">Cutting System</CardTitle>
          <FormGroup row>
            <Label md="2" htmlFor="cutting_system_brand" className="col-form-label">Brand</Label>
            <Col md="10">
              <FormField
                name="cutting_system_brand"
                className="form-control"
                type="text"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md="2" htmlFor="cutting_system_model" className="col-form-label">Model</Label>
            <Col md="10">
              <FormField
                name="cutting_system_model"
                className="form-control"
                type="text"
              />
            </Col>
          </FormGroup>
        </CardBody>
      </Card>
      <Card className="shadow-none border mt-4">
        <CardBody>
          <CardTitle className="mb-3">Print Head Serials</CardTitle>
          <Alert color="danger" role="alert">
            Please note: the following print head serial numbers are
            the original print heads that are installed with the installation
          </Alert>
          <table style={{width: '100%'}}>
            <tbody>
              <tr>
                <td>
                  <Row className="mb-2 px-2">
                    <Label md="2" className="col-form-label">PH Serial colors *</Label>
                    <Col md="4">
                      <Printhead
                        example="FCA0001"
                        name="print_heads[dtrx100][0][serial]"
                        placeholder="Colour PH (1)*"
                        pattern="^[A-Z]{3}[0-9]+$"
                      />
                      <FormField
                        name="print_heads[dtrx100][0][position]"
                        value="1"
                        type="hidden"
                      />
                      <FormField
                        name="print_heads[dtrx100][0][type]"
                        value="color"
                        type="hidden"
                      />
                    </Col>

                    <Label md="2" className="col-form-label">C(1) V.Rating*</Label>
                    <Col md="4">
                      <Vrate name="print_heads[dtrx100][0][vrate]"/>
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  <Row className="mb-2 px-2">
                    <Label md="2" className="col-form-label">PH Serial colors *</Label>
                    <Col md="4">
                      <Printhead
                        example="FCA0001"
                        name="print_heads[dtrx100][1][serial]"
                        placeholder="Colour PH (2)*"
                        pattern="^[A-Z]{3}[0-9]+$"
                      />
                      <FormField
                        name="print_heads[dtrx100][1][position]"
                        value="2"
                        type="hidden"
                      />
                      <FormField
                        name="print_heads[dtrx100][1][type]"
                        value="color"
                        type="hidden"
                      />
                    </Col>

                    <Label md="2" className="col-form-label">C(2) V.Rating *</Label>
                    <Col md="4">
                      <Vrate name="print_heads[dtrx100][1][vrate]"/>
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  <Row className="mb-2 px-2">
                    <Label md="2" className="col-form-label">PH Serial white *</Label>
                    <Col md="4">
                      <Printhead
                        example="FWA0001"
                        name="print_heads[dtrx100][2][serial]"
                        placeholder="White PH (1)*"
                        pattern="^[A-Z]{3}[0-9]+$"/>
                      <FormField
                        name="print_heads[dtrx100][2][position]"
                        value="1"
                        type="hidden"
                      />
                      <FormField
                        name="print_heads[dtrx100][2][type]"
                        value="white"
                        type="hidden"
                      />
                    </Col>

                    <Label md="2" className="col-form-label">W(1) V.Rating *</Label>
                    <Col md="4">
                      <Vrate name="print_heads[dtrx100][2][vrate]"/>
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  <Row className="mb-2 px-2">
                    <Label md="2" className="col-form-label">PH Serial white *</Label>
                    <Col md="4">
                      <Printhead
                        example="FWA0001"
                        name="print_heads[dtrx100][3][serial]"
                        placeholder="White PH (2)*"
                        pattern="^[A-Z]{3}[0-9]+$"/>
                      <FormField
                        name="print_heads[dtrx100][3][position]"
                        value="2"
                        type="hidden"
                      />
                      <FormField
                        name="print_heads[dtrx100][3][type]"
                        value="white"
                        type="hidden"
                      />
                    </Col>

                    <Label md="2" className="col-form-label">W(2) V.Rating *</Label>
                    <Col md="4">
                      <Vrate name="print_heads[dtrx100][3][vrate]"/>
                    </Col>
                  </Row>
                </td>
              </tr>
            </tbody>
          </table>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Dtrx100;
